import { render } from "./NotificationMain.vue?vue&type=template&id=9ce1f67c&scoped=true"
import script from "./NotificationMain.vue?vue&type=script&lang=js"
export * from "./NotificationMain.vue?vue&type=script&lang=js"

import "./NotificationMain.vue?vue&type=style&index=0&id=9ce1f67c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9ce1f67c"]])

export default __exports__